import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';

// project-imports
import TenantLogo from './TenantLogo';
// import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
  showText?: boolean;
  width?: number | string;
  height?: number | string;
}

const LogoSection = ({ reverse, isIcon, sx, to, showText, width, height }: Props) => {
  const logoWidth = width || (isIcon ? 52 : 200);
  const logoHeight = height || (isIcon ? 'auto' : 100);

  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={!to ? APP_DEFAULT_PATH : to}
      sx={sx}
    >
      <TenantLogo
        reverse={reverse}
        showText={showText && !isIcon}
        width={logoWidth}
        height={logoHeight}
      />
    </ButtonBase>
  );
};

export default LogoSection;
